<template>
  <div>
    <div class="rel_title">{{ relatorio.title }}</div>
    <div class="px-4 pt-4">
      <template v-if="selectedRelatorioFiltro">
        <v-row>
          <v-col
            cols="4"
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.municipio)"
          >
            <combobox-municipio
              multiple
              :clearable="true"
              :value="filtros.municipioId"
              @onChange="(e) => (filtros.municipioId = e)"
            ></combobox-municipio>
          </v-col>
          <v-col
            v-if="
              selectedRelatorioFiltro.includes(filtrosEnum.grupoClienteOculto)
            "
          >
            <ComboboxClienteOcultoGrupos
              @onChange="
                (e) =>
                  (filtros.seloClienteOcultoGrupoId = e.map(
                    (item) => item.grupoId
                  ))
              "
            ></ComboboxClienteOcultoGrupos>
          </v-col>
          <v-col
            cols="4"
            v-if="
              selectedRelatorioFiltro.includes(filtrosEnum.responsavel) ||
              selectedRelatorioFiltro.includes(filtrosEnum.usuario)
            "
          >
            <app-consultant-combobox
              :filter="filtros"
              :consultorValue="
                selectedRelatorioFiltro.includes(filtrosEnum.usuario)
                  ? 'Usuário'
                  : 'Responsável'
              "
            ></app-consultant-combobox>
          </v-col>
          <v-col
            cols="3"
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.dataInicial)"
          >
            <datepicker
              :label="relatorioId == 14 ? 'T0' : 'Data Inicial'"
              @onChange="(e) => (filtros.dataInicial = e)"
              :value="filtros.dataInicial"
            >
            </datepicker>
          </v-col>
          <v-col
            cols="3"
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.dataFim)"
          >
            <datepicker
              :label="relatorioId == 14 ? 'T1' : 'Data Final'"
              @onChange="(e) => (filtros.dataFim = e)"
              :value="filtros.dataFim"
            ></datepicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.solucao)">
            <app-solution-combobox
              :filter="filtros"
              @changeSolution="(e) => (filtros.solucaoId = e)"
              multiple
            ></app-solution-combobox>
          </v-col>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.grupoSolucao)"
          >
            <app-group-solution-combobox
              :filter="filtros"
              @changeGroupSolution="(e) => (filtros.grupoSolucaoId = e)"
            ></app-group-solution-combobox>
          </v-col>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.grupoUsuario)"
          >
            <app-group-combobox
              :filter="filtros"
              :placeholderName="'Grupo de usuário'"
            ></app-group-combobox>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.regional)">
            <combobox :filter="filtros" multiple></combobox>
          </v-col>

          <v-col
            v-if="
              selectedRelatorioFiltro.includes(filtrosEnum.statusRelacionamento)
            "
          >
            <app-status-relacionamento
              :filter="filtros"
              :isMultiple="true"
            ></app-status-relacionamento>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.projeto)">
            <combobox-projeto
              :filter="filtros"
              @changeProject="(e) => (filtros.projectId = e)"
            ></combobox-projeto>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.uf)">
            <ComboboxUf :filter="filtros"></ComboboxUf>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.eixo)">
            <combobox-eixo
              :filter="filtros"
              :payloadEixos="[]"
              :label="isSala ? 'Pilar' : 'Eixos'"
            ></combobox-eixo>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.tema)">
            <combobox-tema
              @onChange="(e) => (filtros.temaId = e.map((item) => item.temaId))"
            ></combobox-tema>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.selo)">
            <ComboboxSelo :filter="filtros"> </ComboboxSelo>
          </v-col>
        </v-row>
      </template>
      <v-row class="justify-end px-4">
        <v-btn color="success" class="buttonc" @click="$emit('gerarXlsx')">
          <v-icon dark>mdi-download</v-icon
          >{{ relatorioId == 14 ? "Gerar PDF" : "Gerar XLS" }}
        </v-btn>
        <template v-if="selectedRelatorioFiltro.length">
          <v-btn color="primary" @click="filtrar">{{
            relatorioId == 14 ? "Gerar Relatório" : "Filtrar"
          }}</v-btn>
        </template>
      </v-row>
    </div>
  </div>
</template>
<script>
import ComboboxMunicipio from "@/modules/city/components/ComboboxMunicipio.vue";
import { AppConsultantCombobox } from "@/modules/user";
import Datepicker from "@/components/datepicker/datepicker.vue";
import { AppGroupSolutionCombobox } from "@/modules/group-solution";
import { AppSolutionCombobox } from "@/modules/solution";
import AppGroupCombobox from "@/modules/user/components/group/Combobox";
import AppStatusRelacionamento from "@/modules/city/components/ComboboxStatusRelacionamento";
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard";
import { filtros } from "../../utils/filtros";
import Combobox from "@/modules/ur/components/Combobox";
import ComboboxUf from "@/modules/uf/components/Combobox";
import ComboboxEixo from "@/modules/eixo/components/Autocomplete";
import ComboboxTema from "@/modules/tema/components/TemaCombobox";
import ComboboxProjeto from "@/modules/project/components/Combobox";
import ComboboxClienteOcultoGrupos from "@/modules/clienteOculto/components/ComboboxClienteOcultoGrupos";

import { mapGetters, mapActions } from "vuex";
import ComboboxSelo from "@/modules/selos/components/ComboboxSelo.vue";

const INITIAL_FILTER_VALUES = {
  municipioId: [],
  usuarioId: null,
  grupoSolucaoId: null,
  dataInicial: null,
  dataFim: null,
  solucaoId: [],
  statusId: null,
  id_unidade_regional: [],
  uf: [],
  eixosIds: [],
  temaId: [],
  resposta: [],
  projectId: null,
  seloClienteOcultoGrupoId: [],
  selo: [],
};

export default {
  components: {
    ComboboxMunicipio,
    AppConsultantCombobox,
    Datepicker,
    AppGroupSolutionCombobox,
    AppSolutionCombobox,
    AppGroupCombobox,
    AppStatusRelacionamento,
    Combobox,
    ComboboxUf,
    ComboboxEixo,
    ComboboxTema,
    ComboboxProjeto,
    ComboboxClienteOcultoGrupos,
    ComboboxSelo,
  },
  props: {
    relatorio: Object,
    regional: Array,
  },
  computed: {
    ...mapGetters(["isSala"]),
    relatorioId() {
      return this.relatorio.id;
    },
    selectedRelatorioFiltro() {
      return this.relatorio.filters;
    },
    defaultRelatorioFiltro() {
      return this.relatorio.defaultFilters;
    },
  },
  watch: {
    relatorio: {
      handler(val, oldVal) {
        this.filtros = {
          ...INITIAL_FILTER_VALUES,
          ...this.defaultRelatorioFiltro,
        };
      },
      deep: true,
    },
  },
  data() {
    return {
      filtros: { ...INITIAL_FILTER_VALUES, ...this.defaultRelatorioFiltro },
      filtrosEnum: filtros,
    };
  },
  mounted() {
    this.filtros = {
      ...INITIAL_FILTER_VALUES,
      ...this.defaultRelatorioFiltro,
    };
  },

  methods: {
    filtrar() {
      this.$emit("filtrar", this.filtros);
    },
    gerarXlsx() {
      this.setLoading(true);
      administrativeDashboardAPI
        .getDashboardCities(this.filtros)
        .then((resp) => {
          this.cities = resp.data;

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao buscar dados dos municípios");
        });
    },
  },
};
</script>
<style scoped>
.padding {
  padding: 2rem;
}
.buttonc {
  margin-right: 1rem;
}
.rel_title {
  background: var(--corPrimaria);
  color: #fff;
  padding: 1rem;
  text-align: center;
}
</style>
